import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Box, InputLabel, FormControl } from "@mui/material";

function PhoneInputField({
  name,
  label,
  value,
  onChange,
  onBlur,
  fullWidth = true,
  placeholder = "Enter your phone number",
}) {
  const handleChange = (phoneNumber, data, event) => {
    const syntheticEvent = {
      target: {
        name: name,
        value: phoneNumber,
      },
    };
    
    onChange(syntheticEvent);
  };

  return (
    <FormControl fullWidth={fullWidth} sx={{ mb: 0 }}>
      <InputLabel 
        shrink 
        htmlFor={name}
        sx={{
          color: "black",
          transform: "translate(0, -1.5px) scale(0.75)",
          transformOrigin: "top left",
          "&.Mui-focused": {
            color: "#000",
          },
        }}
      >
        {label}
      </InputLabel>
      
      <Box sx={{ 
        display: "flex", 
        alignItems: "center",
        "& .react-tel-input": {
          width: "100%",
        },
        "& .react-tel-input .form-control": {
          width: "100%",
          height: "56px",
          borderRadius: "4px",
          borderColor: "grey",
          borderWidth: "2px",
          color: "black",
          backgroundColor: "#f5f5f5",
          fontSize: "16px",
          paddingLeft: "58px",
          "&:hover": {
            borderColor: "#23A215",
          },
          "&:focus": {
            borderColor: "#23A215",
            boxShadow: "none",
          },
        },
        "& .react-tel-input .flag-dropdown": {
          borderColor: "grey",
          borderWidth: "2px",
          borderRight: "none",
          backgroundColor: "#f5f5f5",
          borderRadius: "4px 0 0 4px",
          "&:hover": {
            borderColor: "#23A215",
          },
          "&.open": {
            borderColor: "#23A215",
            backgroundColor: "#f5f5f5",
          },
        },
        "& .special-label": {
          display: "none",
        },
      }}>
        
        <PhoneInput
          country={"au"}
          enableSearch={true}
          disableSearchIcon={true}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          inputProps={{
            name: name,
            id: name,
          }}
          containerStyle={{
            width: "100%",
          }}
        />
      </Box>
    </FormControl>
  );
}

export default PhoneInputField;